// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolActionDescriptors .table-responsive {
  overflow: visible;
}

.SuperAdminSchoolActionDescriptors .react-datepicker-popper {
  z-index: 10000 !important;
}

.SuperAdminSchoolActionDescriptors .text-monospace {
  font-size: 12px;
}

.SuperAdminActionDescriptorDetailsBackdrop {
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.35);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  overflow-y: auto;
  padding: 40px 20px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1050;
}

.SuperAdminActionDescriptorDetailsModal {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.22);
  max-width: 1100px;
  padding: 24px;
  width: 100%;
}

.SuperAdminActionDescriptorDetailsSection {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 16px;
}

.SuperAdminActionDescriptorDetailsSection h6 {
  margin-bottom: 12px;
}

.SuperAdminActionDescriptorDetailsSection pre {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 0;
  max-height: 420px;
  overflow: auto;
  padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/ActionDescriptors/SuperAdminSchoolActionDescriptors.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf","sourcesContent":[".SuperAdminSchoolActionDescriptors .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminSchoolActionDescriptors .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n\n.SuperAdminSchoolActionDescriptors .text-monospace {\n  font-size: 12px;\n}\n\n.SuperAdminActionDescriptorDetailsBackdrop {\n  align-items: flex-start;\n  background: rgba(0, 0, 0, 0.35);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  overflow-y: auto;\n  padding: 40px 20px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1050;\n}\n\n.SuperAdminActionDescriptorDetailsModal {\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.22);\n  max-width: 1100px;\n  padding: 24px;\n  width: 100%;\n}\n\n.SuperAdminActionDescriptorDetailsSection {\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  padding: 16px;\n}\n\n.SuperAdminActionDescriptorDetailsSection h6 {\n  margin-bottom: 12px;\n}\n\n.SuperAdminActionDescriptorDetailsSection pre {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-bottom: 0;\n  max-height: 420px;\n  overflow: auto;\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
